export const TOOL_STATUS = {
	active: 'active',
	inactive: 'inactive',
	cancelled: 'cancelled',
}

export const TOOL_STATUES = [
	{
		value: 'active',
		text: 'Active',
	},
	{
		value: 'inactive',
		text: 'Inactive',
	},
	{
		value: 'cancelled',
		text: 'Cancelled',
	},
]
export const TOOL_STATUS_REASON = {
	DRAFT: 'draft',
	DECOMMISSIONED: 'decommissioned',
	CANCELLED_DATA_ENTRY_LINE: 'cancelled-data-entry-line'
}


export const TOOL_STATUS_REASONS = [
	{
		value: 'active',
		text: 'Active',
		status: TOOL_STATUS.active
	},
	{
		value: TOOL_STATUS_REASON.DRAFT,
		text: 'Draft',
		status: TOOL_STATUS.inactive
	},
	{
		value: 'breakdown',
		text: 'Breakdown',
		status: TOOL_STATUS.inactive
	},
	{
		value: 'temporary-not-to-use',
		text: 'Temporary Not to Use',
		status: TOOL_STATUS.inactive
	},
	{
		value: TOOL_STATUS_REASON.DECOMMISSIONED,
		text: 'Decommissioned',
		status: TOOL_STATUS.inactive
	},
	{
		value: 'calibration-expired',
		text: 'Calibration Expired',
		status: TOOL_STATUS.inactive
	},
	{
		value: TOOL_STATUS_REASON.CANCELLED_DATA_ENTRY_LINE,
		text: 'Cancelled Data Entry Line',
		status: TOOL_STATUS.cancelled
	},
]


export const TOOL_CERT_STATUES = [
	{
		value: 'Approved',
		text: 'Approved',
	},
	{
		value: 'Rejected',
		text: 'Rejected',
	}
]
